import { FetchingAction, FetchingType, State } from '../types';
import { Reducer } from 'redux';

const reducer: Reducer<State, FetchingAction> = (
  state: any = [],
  action: FetchingAction,
): State => {
  switch (action.type) {
    case FetchingType.FETCHING_COMPLETED:
    case FetchingType.FETCHING:
      return {
        ...state,
        isFetching: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
